
export default class CategorySwitcher {
	constructor() {

		this.el = {
			categorySwitcher: document.querySelector('[data-category-switcher]')
		};

		if (!this.el.categorySwitcher) {
			return;
		}

		this._addListeners();
	}

	_addListeners() {
		this._onChange = this._onChange.bind(this);
		this.el.categorySwitcher.addEventListener('change', this._onChange);
	}

	_onChange(e) {
		console.log(e);
		window.location.href = this.el.categorySwitcher.value;
	}
}
